<template>
  <div class='portfolio'>
    
    <nav :class="{'active': menu}">
      <div class="nav-mobile">
        <a>Portfolio</a> 
        <span class="sub" :class="{'active': filterIsActive('Empresa')}" @click="setFilter('Empresa'); menu = false"> Empresa </span>
        <span class="sub" :class="{'active': filterIsActive('Institucional')}" @click="setFilter('Institucional'); menu = false">Institucional</span>
        <span class="sub" :class="{'active': filterIsActive('Editorial')}" @click="setFilter('Editorial'); menu = false">Editorial</span>
        <span class="sub" :class="{'active': filterIsActive('Em rede')}" @click="setFilter('Em rede'); menu = false">Em rede</span>
        <router-link to="/atelier">Atelier </router-link>
        <router-link to="/registos">Registos </router-link>
        <router-link to="/contactos">Contactos</router-link>
      </div>
      <div class="nav-left">
        <span class="current">Portfolio</span>  <span class="extra">&nbsp;</span> 
        <span class="sub" :class="{'active': filterIsActive('Empresa')}" @click="setFilter('Empresa'); menu = false"> Empresa </span>
        <span class="separador">&nbsp;</span>
        <span class="sub" :class="{'active': filterIsActive('Institucional')}" @click="setFilter('Institucional'); menu = false">Institucional</span>
        <span class="separador">&nbsp;</span>
        <span class="sub" :class="{'active': filterIsActive('Editorial')}" @click="setFilter('Editorial'); menu = false">Editorial</span>
        <span class="separador">&nbsp;</span>
        <span class="sub" :class="{'active': filterIsActive('Em rede')}" @click="setFilter('Em rede'); menu = false">Em rede</span>

      </div>
      <div class="nav-right">
        <router-link to="/atelier">Atelier </router-link>
        <span class="separador">&nbsp;</span>
        <router-link to="/registos">Registos </router-link>
        <span class="separador">&nbsp;</span>
        <router-link to="/contactos">Contactos</router-link>
      </div>
    </nav>

    <div class="open-menu">
      <div @click="menu = true">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <main class="portfolio-content">
      <carousel :navigationPrevLabel="'❬'" :navigationNextLabel="'❭'" :perPageCustom="[[320, 1], [768, 3], [1024, 5]]" :navigationEnabled="true" :paginationEnabled="false" :scrollPerPage="true" class="slider">
        <slide class="portfolio-slide" v-for="projecto in filterBy(projectos, filter, 'categoria')" :key="projecto.id">
          <router-link :to="{ name: 'PortfolioWork', params: { title:projecto.titulo, categoria:projecto.categoria, uid: projecto.uid }}" style="cursor: pointer;">
            <img class="portfolio-img" :src="'http://atelieradaoparanhos.com' + projecto.destaque">
            <div class="portfolio-desc" v-html="projecto.descricao">
            </div>
          </router-link>
        </slide>
      </carousel>
    </main>

  </div>

</template>

<script>

import { Carousel, Slide } from 'vue-carousel'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue2Filters from 'vue2-filters'

export default {
  mixins: [Vue2Filters.mixin],
  name: 'Portfolio',
  data () {
    return {
      menu: true,
      filter: 'Empresa',
      projectos: [
      ]
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    setFilter: function (newFilter) {
      this.filter = newFilter
    },
    filterIsActive: function (currentFilter) {
      return this.filter === currentFilter
    },
    loadPortfolio: function () {
      var app = this
      axios.get('/admin/api/portfolio').then((response) => {
        app.projectos = response.data
      })
    }
  },
  mounted: function () {
    if (this.$route.params.categoria) {
      this.filter = this.$route.params.categoria
    }
    this.loadPortfolio()
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang='scss'>


.portfolio {
  height: 100%;
  
  &-content {

    max-width: 1920px;
    margin: 0 auto;

    .VueCarousel {
      &-wrapper {
        margin: 0 auto;
      }
    }  
  }

  &-slide {
    margin: 0 2px;
  }

  &-img {
    width: 100%;
  }
  &-desc {
    max-width: 200px;
    font-size: 10px;
    line-height: 16px;
    padding-top: 20px;
    margin-top: 40px;
    font-family: Georgia;
    color: #6e6e6e;
    border-top: 2px solid #6e6e6e;
    
    
  }
}

@media (max-width: 768px) {
  .portfolio-content .VueCarousel-wrapper {
    width: calc(100% - 70px);
  }
  .portfolio-img {
      width: calc(100% - 100px);
  }
}

@media (min-width: 1920px) {
  .portfolio-desc {
    max-width: 230px;
    font-size: 13px;
    line-height: 20px;
  }
}

</style>
